// Core Imports
import React from 'react';
import { motion } from "framer-motion";
import { CustomButton } from '../parts/Parts';

const CaseStudy = ({ caseStudy }) => {
  return (
    <>

      {caseStudy.case_study_status == "active" ? (
        <motion.div className="row case-study"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75 }}>
          <div className="col col-xs-12 col-sm-3 col-md-3 col-lg-3">

            <h3 className='case_study_title'>{caseStudy.case_study_title}</h3>
            <div className="custom-button-container">
              <CustomButton type="alt-white" text="View Casestudy" to={`/case-studies/${caseStudy.case_study_id}`} />
            </div>
          </div>
          <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
            {caseStudy.case_study_tags && caseStudy.case_study_tags.length > 0 ? (
              <div className="case-study-tags-container">
                {caseStudy.case_study_tags.map((tag, index) => (
                  <span key={index} className="case-study-tag">{tag}</span>
                ))}
              </div>
            ) : ("")}
            <p className='case-study-description'>{caseStudy.case_study_description[0]}</p>
            <div className="custom-button-container">
              <CustomButton type="alt-white" text="View Casestudy" to={`/case-studies/${caseStudy.case_study_id}`} />
            </div>
          </div>
          <div className="col col-xs-12 col-sm-1 col-md-1 col-lg-1">
            <p className='case_study_id_alt'>{caseStudy.case_study_id_alt}</p>
          </div>
        </motion.div>
      ) : ("")}

    </>
  );
};

export default CaseStudy;
